<template>
    <div class="flex items-center p-4 border-b border-gray-200">
        <div class="coach-image w-24 rounded-full overflow-hidden mr-4 relative" style="padding-bottom: 100%;">
            <img :src="coach.image" alt="Coach Profile" class="w-full h-full object-cover transition transform hover:scale-110 absolute inset-0"/>
        </div>
        <div class="flex-1 mr-4">
          <h3 class="font-oswald text-xl text-gray-800 mb-1">{{ coach.name }}</h3>
          <p class="font-medium text-gray-600 mb-1">{{ coach.title }}</p>
            <p class="text-gray-500 text-sm">{{ coach.bio }}</p>
        </div>
       <div class="flex-shrink-0 flex items-center justify-end gap-2">
        <div class="flex items-center justify-end flex-wrap gap-1 mb-2">
            <template v-if="!showAllLabels">
                 <span v-for="(label) in coach.labels.slice(0, 2)" :key="label" class="bg-gray-200 text-gray-600 px-2 py-1 rounded text-xs">
                    {{ label }}
                  </span>
                <span v-if="coach.labels.length > 2" @click="toggleLabels"
                      class="text-gray-600 text-xs cursor-pointer hover:text-gray-800">...</span>
            </template>
             <template v-else>
                 <span v-for="label in coach.labels" :key="label" class="bg-gray-200 text-gray-600 px-2 py-1 rounded text-xs">
                    {{ label }}
                </span>
                 <span @click="toggleLabels" class="text-gray-600 text-xs cursor-pointer hover:text-gray-800">-</span>
            </template>
         </div>
          <div class="text-right mb-2">
            <p class="font-bold text-gray-600 text-sm">{{ coach.price }}</p>
         </div>
         <button
             @click="$emit('book', coach)"
             :disabled="!coach.available"
           class="coach-buy-button bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline transition transform hover:scale-105  disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed"
             >
            {{ coach.available ? 'Agendar' : 'Sin Disponibilidad' }}
         </button>
         </div>
   </div>
</template>

<script>
export default {
    props: {
        coach: { type: Object, required: true }
   },
    emits: ['book'],
    data(){
        return{
          showAllLabels: false,
        }
    },
   methods: {
          toggleLabels() {
            this.showAllLabels = !this.showAllLabels;
        },
   }
}
</script>